import { render, staticRenderFns } from "./ProductsCRMReports.vue?vue&type=template&id=67d7a15e&scoped=true"
import script from "./ProductsCRMReports.vue?vue&type=script&lang=js"
export * from "./ProductsCRMReports.vue?vue&type=script&lang=js"
import style0 from "./ProductsCRMReports.vue?vue&type=style&index=0&id=67d7a15e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d7a15e",
  null
  
)

export default component.exports